import { type Control, type FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormPhoneInput } from '@/components/form/form-phone-input';
import { FormText } from '@/components/form/form-text';
import { useRules } from '@/hooks/use-rules';

interface IProps<T extends FieldValues> {
  type: 'email' | 'phone';
  control: Control<T>;
}

export function FormUsernameInput<T extends FieldValues>(props: IProps<T>) {
  const { type, control } = props;
  const { t } = useTranslation();

  const rules = useRules();

  return type === 'email' ? (
    <FormText name="email" label={t('email_address')} control={control} rules={rules.email} />
  ) : (
    <FormPhoneInput control={control} />
  );
}
